<div style="margin: 24px 8px;">
    @if(errorCode){
    <div style="margin: 8px 0; font-size: 14px;">
        <b>Error:</b> {{errorCode}}
    </div>
    }
    <div style="margin: 24px 0;">
        <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [disableSelection]="true" [cols]="detailsCols"
            [data]="claimTSData" [from]="'claimAdj'"></ppl-list-table>
    </div>
</div>